import DOMPurify from 'dompurify';

export const sanitizeNotificationBody = (html: string) =>
  DOMPurify.sanitize(html, { ADD_ATTR: ['style'] });
